var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g(
      {
        staticClass: "editor-toolbar-view",
        class: { "editor-toolbar-view-disabled": _vm.disabled },
      },
      _vm.$listeners
    ),
    [
      _c(
        "div",
        {
          ref: "mainOptions",
          staticClass: "main-options",
          style: _vm.mainOptionStyles,
        },
        [
          _vm.internalPhotoObject
            ? [
                _c(
                  "button",
                  { on: { click: _vm.onDeleteClick } },
                  [
                    _c("IconComponent", [_vm._v("delete")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("views.editorToolbar.delete"))),
                    ]),
                  ],
                  1
                ),
                _c("divider", {
                  staticClass: "divider full",
                  class: { horizontal: !_vm.isMobile },
                }),
                _c(
                  "button",
                  {
                    class: { active: _vm.isCropActive },
                    on: { click: _vm.onCropClick },
                  },
                  [
                    _c("IconComponent", [_vm._v("crop")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("views.editorToolbar.crop"))),
                    ]),
                  ],
                  1
                ),
                _c(
                  "button",
                  { on: { click: _vm.onRotateClick } },
                  [
                    _c("IconComponent", [_vm._v("rotate")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("views.editorToolbar.rotate"))),
                    ]),
                  ],
                  1
                ),
                _c(
                  "button",
                  { on: { click: _vm.onFitOrFillToSizeClick } },
                  [
                    _c("IconComponent", [
                      _vm._v(
                        _vm._s(
                          _vm.isFittedToSize ? "fill_to_size" : "fit_to_size"
                        )
                      ),
                    ]),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.isFittedToSize
                            ? _vm.$t("views.editorToolbar.fillSize")
                            : _vm.$t("views.editorToolbar.fitSize")
                        )
                      ),
                    ]),
                  ],
                  1
                ),
                _vm.productType !== "logo"
                  ? _c(
                      "button",
                      {
                        class: { active: _vm.isFilterActive },
                        on: { click: _vm.onFilterClick },
                      },
                      [
                        _c("IconComponent", [_vm._v("filter")]),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("views.editorToolbar.filter"))),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.productType !== "logo"
                  ? _c(
                      "button",
                      {
                        class: { active: _vm.isShapeActive },
                        on: { click: _vm.onShapeClick },
                      },
                      [
                        _c("IconComponent", [_vm._v("shape")]),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("views.editorToolbar.shape"))),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "button",
                  {
                    class: {
                      active: _vm.isBackgroundActive,
                      hidden: !_vm.isBackgroundEnabled,
                    },
                    on: { click: _vm.onBackgroundClick },
                  },
                  [
                    _c("IconComponent", [_vm._v("bg_color")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("views.editorToolbar.background"))),
                    ]),
                  ],
                  1
                ),
                _vm.toolsSupported.text
                  ? _c("divider", {
                      staticClass: "divider full",
                      class: { horizontal: !_vm.isMobile },
                    })
                  : _vm._e(),
                _vm.toolsSupported.text
                  ? _c(
                      "button",
                      { on: { click: _vm.onAddEditTextClick } },
                      [
                        _c("IconComponent", [
                          _vm._v(
                            _vm._s(
                              !_vm.hasTextObject ? "add_text" : "edit_text"
                            )
                          ),
                        ]),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              !_vm.hasTextObject
                                ? _vm.$t("views.editorToolbar.add.text")
                                : _vm.$t("views.editorToolbar.edit.text")
                            )
                          ),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            : [
                _c(
                  "button",
                  {
                    class: {
                      hidden: !_vm.hasPreview,
                    },
                    on: { click: _vm.onPreviewClick },
                  },
                  [
                    _c("IconComponent", [_vm._v("preview")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("views.editorToolbar.preview"))),
                    ]),
                  ],
                  1
                ),
                _c("divider", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hasPreview,
                      expression: "hasPreview",
                    },
                  ],
                  staticClass: "divider full",
                  class: { horizontal: !_vm.isMobile },
                }),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasPhotoObject,
                        expression: "hasPhotoObject",
                      },
                    ],
                    class: { active: _vm.isEditPhotoActive },
                    on: { click: _vm.onEditPhotoClick },
                  },
                  [
                    _c("IconComponent", [_vm._v("edit")]),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("views.editorToolbar.edit." + _vm.productType)
                        )
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasTextObject,
                        expression: "hasTextObject",
                      },
                    ],
                    class: { active: _vm.isEditTextActive },
                    on: { click: _vm.onEditTextClick },
                  },
                  [
                    _c("IconComponent", [_vm._v("edit_text")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("views.editorToolbar.edit.text"))),
                    ]),
                  ],
                  1
                ),
                _c("divider", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        (_vm.hasPhotoObject || _vm.hasTextObject) &&
                        (!_vm.hasPhotoObject ||
                          _vm.toolsSupported.multiplePhoto ||
                          _vm.isBackgroundEnabled ||
                          (_vm.toolsSupported.text &&
                            (!_vm.hasTextObject ||
                              _vm.toolsSupported.multipleText)) ||
                          _vm.toolsSupported.layout ||
                          _vm.toolsSupported.theme ||
                          _vm.hasMultipleObjectsOfKind),
                      expression:
                        "(\n\t\t\t\t\t(\n\t\t\t\t\t\thasPhotoObject\n\t\t\t\t\t\t|| hasTextObject\n\t\t\t\t\t)\n\t\t\t\t\t&& (\n\t\t\t\t\t\t(\n\t\t\t\t\t\t\t!hasPhotoObject\n\t\t\t\t\t\t\t|| toolsSupported.multiplePhoto\n\t\t\t\t\t\t)\n\t\t\t\t\t\t|| isBackgroundEnabled\n\t\t\t\t\t\t|| (\n\t\t\t\t\t\t\ttoolsSupported.text\n\t\t\t\t\t\t\t&& (\n\t\t\t\t\t\t\t\t!hasTextObject\n\t\t\t\t\t\t\t\t|| toolsSupported.multipleText\n\t\t\t\t\t\t\t)\n\t\t\t\t\t\t)\n\t\t\t\t\t\t|| toolsSupported.layout\n\t\t\t\t\t\t|| toolsSupported.theme\n\t\t\t\t\t\t|| hasMultipleObjectsOfKind\n\t\t\t\t\t)\n\t\t\t\t)",
                    },
                  ],
                  staticClass: "divider full",
                  class: { horizontal: !_vm.isMobile },
                }),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.hasPhotoObject || _vm.isAddPhotoAvailable,
                        expression: "!hasPhotoObject || isAddPhotoAvailable",
                      },
                    ],
                    on: { click: _vm.onAddPhotoClick },
                  },
                  [
                    _c("IconComponent", [_vm._v("add_photo")]),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("views.editorToolbar.add." + _vm.productType)
                        )
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "button",
                  {
                    class: {
                      active: _vm.isBackgroundActive,
                      hidden: !_vm.isBackgroundEnabled,
                    },
                    on: { click: _vm.onBackgroundClick },
                  },
                  [
                    _c("IconComponent", [_vm._v("bg_color")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("views.editorToolbar.background"))),
                    ]),
                  ],
                  1
                ),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.toolsSupported.text &&
                          (!_vm.hasTextObject ||
                            _vm.toolsSupported.multipleText),
                        expression:
                          "toolsSupported.text && (!hasTextObject || toolsSupported.multipleText)",
                      },
                    ],
                    on: { click: _vm.onAddTextClick },
                  },
                  [
                    _c("IconComponent", [_vm._v("add_text")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("views.editorToolbar.add.text"))),
                    ]),
                  ],
                  1
                ),
                _vm.toolsSupported.layout
                  ? _c(
                      "button",
                      {
                        class: { active: _vm.isLayoutActive },
                        on: { click: _vm.onLayoutClick },
                      },
                      [
                        _c("IconComponent", [_vm._v("layout")]),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("views.editorToolbar.layout"))),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.toolsSupported.frame
                  ? _c(
                      "button",
                      { on: { click: _vm.onAddFrameClick } },
                      [
                        _c("IconComponent", [_vm._v("add_frame")]),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("views.editorToolbar.add.frame"))
                          ),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.toolsSupported.theme
                  ? _c(
                      "button",
                      {
                        class: { active: _vm.isThemeActive },
                        on: { click: _vm.onThemesClick },
                      },
                      [
                        _c("IconComponent", [_vm._v("themes")]),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("views.editorToolbar.themes"))),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.toolsSupported.shuffle
                  ? _c(
                      "button",
                      { on: { click: _vm.onShuffleClick } },
                      [
                        _c("IconComponent", [_vm._v("shuffle")]),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("views.editorToolbar.shuffle"))),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.hasMultipleObjectsOfKind ||
                          (_vm.hasPhotoObject && _vm.hasTextObject),
                        expression:
                          "hasMultipleObjectsOfKind || (hasPhotoObject && hasTextObject)",
                      },
                    ],
                    class: { active: _vm.isLayersActive },
                    on: { click: _vm.onLayersClick },
                  },
                  [
                    _c("IconComponent", [_vm._v("layers")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("views.editorToolbar.layers"))),
                    ]),
                  ],
                  1
                ),
                _vm.toolsSupported.deletePage
                  ? [
                      _c("divider", {
                        staticClass: "divider full",
                        class: { horizontal: !_vm.isMobile },
                      }),
                      _c(
                        "button",
                        { on: { click: _vm.onDeletePageClick } },
                        [
                          _c("IconComponent", [_vm._v("delete_page")]),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("views.editorToolbar.deletePage"))
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
              ],
        ],
        2
      ),
      _c("divider", {
        staticClass: "divider full options-divider",
        class: { horizontal: _vm.isMobile },
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.isBackgroundActive ||
                _vm.isEditPhotoActive ||
                _vm.isFilterActive ||
                _vm.isLayersActive ||
                _vm.isLayoutActive ||
                _vm.isShapeActive ||
                _vm.isEditTextActive ||
                _vm.isThemeActive,
              expression:
                "\n\t\t\tisBackgroundActive\n\t\t\t|| isEditPhotoActive\n\t\t\t|| isFilterActive\n\t\t\t|| isLayersActive\n\t\t\t|| isLayoutActive\n\t\t\t|| isShapeActive\n\t\t\t|| isEditTextActive\n\t\t\t|| isThemeActive\n\t\t",
            },
          ],
          staticClass: "sub-options",
          class: { "is-background": _vm.isBackgroundActive },
          style: _vm.subOptionsStyles,
        },
        [
          !_vm.isMobile
            ? _c(
                "div",
                {
                  staticClass: "sub-options-header",
                  class: { "is-background": _vm.isBackgroundActive },
                },
                [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isBackgroundActive,
                          expression: "isBackgroundActive",
                        },
                      ],
                    },
                    [_vm._v(_vm._s(_vm.$t("views.editorToolbar.background")))]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEditPhotoActive,
                          expression: "isEditPhotoActive",
                        },
                      ],
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("views.editorToolbar.edit." + _vm.productType)
                        )
                      ),
                    ]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEditTextActive,
                          expression: "isEditTextActive",
                        },
                      ],
                    },
                    [_vm._v(_vm._s(_vm.$t("views.editorToolbar.edit.text")))]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isFilterActive,
                          expression: "isFilterActive",
                        },
                      ],
                    },
                    [_vm._v(_vm._s(_vm.$t("views.editorToolbar.filter")))]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isLayersActive,
                          expression: "isLayersActive",
                        },
                      ],
                    },
                    [_vm._v(_vm._s(_vm.$t("views.editorToolbar.layers")))]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isLayoutActive,
                          expression: "isLayoutActive",
                        },
                      ],
                    },
                    [_vm._v(_vm._s(_vm.$t("views.editorToolbar.chooseLayout")))]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShapeActive,
                          expression: "isShapeActive",
                        },
                      ],
                    },
                    [_vm._v(_vm._s(_vm.$t("views.editorToolbar.shape")))]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isThemeActive,
                          expression: "isThemeActive",
                        },
                      ],
                    },
                    [_vm._v(_vm._s(_vm.$t("views.editorToolbar.chooseTheme")))]
                  ),
                  _c(
                    "IconComponent",
                    {
                      staticClass: "sub-options-header-close-button clickable",
                      on: { click: _vm.onSubOptionsCloseClick },
                    },
                    [_vm._v("close")]
                  ),
                  _c("div", { staticClass: "sub-options-header-divider" }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "sub-options-content",
              class: _vm.subOptionsContentClasses,
            },
            [
              _vm.isBackgroundActive
                ? _c("ColorPicker", {
                    ref: "colorPicker",
                    attrs: {
                      canvas: _vm.computedCanvas,
                      large: _vm.isMobile,
                      magnification: _vm.colorPickerMagnification,
                      patterns: _vm.colorPickerPatterns,
                      value: _vm.pageModelBackground,
                    },
                    on: {
                      change: _vm.onBackgroundColorChange,
                      "eye-dropper-end": _vm.onEyeDropperEnd,
                      "eye-dropper-start": _vm.onEyeDropperStart,
                    },
                  })
                : _vm._e(),
              _vm._l(
                _vm.filtersForRender,
                function (filterForRender, filterName) {
                  return _vm.isFilterActive
                    ? [
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isFilterActive,
                                expression: "isFilterActive",
                              },
                            ],
                            class: { active: _vm.isFilterSelected(filterName) },
                            on: {
                              click: function ($event) {
                                return _vm.onFilterForRenderClick(filterName)
                              },
                            },
                          },
                          [
                            _c("img", { attrs: { src: filterForRender } }),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "views.editorToolbar.filters." + filterName
                                  )
                                )
                              ),
                            ]),
                          ]
                        ),
                        filterName === "none" && _vm.isMobile
                          ? _c("divider", { staticClass: "divider full" })
                          : _vm._e(),
                      ]
                    : _vm._e()
                }
              ),
              !_vm.isMobile && _vm.isLayersActive
                ? _c("EditorLayerListView", {
                    attrs: {
                      columns: 1,
                      objects: _vm.internalObjects,
                      "object-photo-size": 100,
                      photos: _vm.photos,
                      theme: "light",
                    },
                    on: { change: _vm.onEditorLayerListChange },
                  })
                : _vm._e(),
              !_vm.isMobile && _vm.isLayoutActive
                ? _c("EditorLayoutSelectorView", {
                    attrs: {
                      columns: 1,
                      layouts: _vm.layouts,
                      "page-model": _vm.pageModel,
                      value: _vm.pageModelTemplateSet,
                      width: _vm.subOptionsMaxWidth,
                      theme: "light",
                    },
                    on: { change: _vm.onLayoutChange },
                  })
                : _vm._e(),
              !_vm.isMobile && (_vm.isEditPhotoActive || _vm.isEditTextActive)
                ? _c("EditorObjectSelectorView", {
                    attrs: {
                      columns: _vm.isEditPhotoActive ? 2 : 1,
                      objects: _vm.isEditPhotoActive
                        ? _vm.photoObjects
                        : _vm.textObjects,
                      "object-photo-size": _vm.isEditPhotoActive
                        ? 100
                        : undefined,
                      photos: _vm.isEditPhotoActive ? _vm.photos : undefined,
                      value: _vm.isEditPhotoActive
                        ? _vm.internalPhotoObject
                        : _vm.selectedTextObject,
                      theme: "light",
                    },
                    on: {
                      change: _vm.onSelectedObjectChange,
                      "objects-change": _vm.onEditorObjectSelectorObjectsChange,
                    },
                  })
                : _vm._e(),
              _vm._l(_vm.shapesForRender, function (shapeForRender, shapeName) {
                return _vm.isShapeActive
                  ? [
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isShapeActive,
                              expression: "isShapeActive",
                            },
                          ],
                          class: { active: _vm.isShapeSelected(shapeName) },
                          on: {
                            click: function ($event) {
                              return _vm.onShapeForRenderClick(shapeName)
                            },
                          },
                        },
                        [
                          _c("img", { attrs: { src: shapeForRender } }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "views.editorToolbar.shapes." + shapeName
                                )
                              )
                            ),
                          ]),
                        ]
                      ),
                      shapeName === "none" && _vm.isMobile
                        ? _c("divider", { staticClass: "divider full" })
                        : _vm._e(),
                    ]
                  : _vm._e()
              }),
              !_vm.isMobile && _vm.isThemeActive
                ? _c("EditorThemeSelectorView", {
                    attrs: {
                      columns: 2,
                      "project-group-id": _vm.projectModel.group,
                      themes: _vm.themes,
                      "theme-image-size": 100,
                      value: _vm.projectTheme,
                      theme: "light",
                    },
                    on: { change: _vm.onThemeChange },
                  })
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }